import Target_0 from './src/ValidationSettings.jsx';shopify.extend('admin.settings.validation.render', (...args) => Target_0(...args));